import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface DetailSectionProps {
  title: string;
  icon?: LucideIcon;
  /** Contagem opcional exibida ao lado do título (ex.: "Projetos (3)"). */
  count?: number;
  /** Ação à direita do cabeçalho (botão, etc.). */
  action?: ReactNode;
  /** Subtítulo curto abaixo do título. */
  description?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Bloco de conteúdo em formato de "seção" (divisória + cabeçalho enxuto) no lugar
 * dos cards espaçosos. Aproveita melhor a largura da tela no detalhe do freelancer.
 */
export function DetailSection({
  title,
  icon: Icon,
  count,
  action,
  description,
  className,
  children,
}: DetailSectionProps) {
  return (
    <section className={cn("border-t border-border/60 pt-6", className)}>
      <div className="mb-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="flex items-center gap-2 text-base font-semibold text-foreground">
            {Icon && <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />}
            <span className="truncate">{title}</span>
            {typeof count === "number" && (
              <span className="text-sm font-normal text-muted-foreground">({count})</span>
            )}
          </h2>
          {description && (
            <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      {children}
    </section>
  );
}

export default DetailSection;
